// NOTE: v3 curriculum path (useMarkCompleteV3). New mark-complete features belong here.
// For learning experiences, please refer to components/HsIndividualResourceMarkComplete

import MarkCompleteSectionContainer from './container'
export default MarkCompleteSectionContainer
